export const setTriggerAnyEvent = (triggeranyevent) => {
  return {
    type: "SET_TRIGGERANYEVENT",
    payload: triggeranyevent,
  };
};
